import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import mapResponse from '../../components/Main/Forms/Body/CanvasForm/ManageObjects/mapResponseFunctions';

export default function ManageObjectsReducer(state = initialstate.manageObjects, action) {
	switch (action.type) {
		case types.GET_All_SCOTS: {
			if (action.response && Array.isArray(action.response.data) && !action.error) {
				if (action.expand) {
					if (action.expand.toLowerCase() === 'controls') {
						return mapResponse.ScotsControls(action.response.data);
					} else if (action.expand.toLowerCase() === 'wcgw') {
						return action.response.data;
					}
				} else {
					return mapResponse.Scot(action.response.data);
				}
			}
			return state;
		}
		case types.GET_ALL_ITSOAPPLICATIONS: {
			if (action.response && Array.isArray(action.response.data) && !action.error) {
				return mapResponse.ItsoApplication(action.response);
			}
			return state;
		}
		default:
			return state;
	}
}
